import { combineReducers } from 'redux';
import { createReduxHistoryContext   } from 'redux-first-history';
import auth from './auth/reducers';
import menu from './menu/reducers';
import settings from './settings/reducers';

const { routerReducer } = createReduxHistoryContext({ history });

export default (history) =>
  combineReducers({
    router: routerReducer(history), // ✅ Replaced `connectRouter` with `routerReducer`
    auth,
    menu,
    settings,
  });
